export type EntraPortalType = 'dealer' | 'admin';
export type EntraRuntimeMode = 'STAGING' | 'PRODUCTION' | 'DEV';

export const entraBaseUrlByMode: Record<EntraRuntimeMode, string> = {
  STAGING: 'https://808e2a93-170b-4166-981b-1c66f73cd385.ciamlogin.com',
  PRODUCTION: 'https://authaqua.ciamlogin.com',
  DEV: 'https://808e2a93-170b-4166-981b-1c66f73cd385.ciamlogin.com',
};

export const tenantIdByEnv: Record<EntraRuntimeMode, string> = {
  STAGING: '808e2a93-170b-4166-981b-1c66f73cd385',
  PRODUCTION: 'be0b35c4-0e00-4730-8c48-9fb97eac2f26',
  DEV: '808e2a93-170b-4166-981b-1c66f73cd385',
};

export const entraTenantIdTest = tenantIdByEnv.STAGING;

export const clientIdByPortalAndMode: Record<EntraRuntimeMode, Record<EntraPortalType, string>> = {
  STAGING: {
    dealer: 'b59b81b8-de59-4632-9c68-534771c9c633',
    admin: '2c5b9572-6f9f-4655-88c7-d42ea5255674',
  },
  PRODUCTION: {
    dealer: 'a018a9c8-cfbd-43b8-9c06-07511379fd41',
    admin: '27eaf36c-21c3-45f0-874f-9de0a5ded384',
  },
  DEV: {
    dealer: 'b59b81b8-de59-4632-9c68-534771c9c633',
    admin: '2c5b9572-6f9f-4655-88c7-d42ea5255674',
  },
};

export const redirectUriByPortalAndMode: Record<EntraPortalType, Record<EntraRuntimeMode, string>> = {
  dealer: {
    STAGING: 'https://pwr-dlr-stage.aquafinance.com/entra-mfa-processing',
    PRODUCTION: 'https://power-dealer.aquafinance.com/entra-mfa-processing',
    DEV: 'https://pwr-dealer-dev-aks.aquafinance.com/entra-mfa-processing',
  },
  admin: {
    STAGING: 'https://pwr-adm-stage.aquafinance.com/entra-mfa-processing',
    PRODUCTION: 'https://power-admin.aquafinance.com/entra-mfa-processing',
    DEV: 'https://pwr-admin-dev-aks.aquafinance.com/entra-mfa-processing',
  },
};

export const entraSharedParams = {
  scope: 'openid profile email',
  response_type: 'id_token',
  prompt_admin: '',
  prompt_dealer: 'select_account',
  nonce: '6CZGixX0uc',
} as const;
